import { getWrapper, wrapper } from '../request';
export var getUserInfo = getWrapper('common')('getUserInfo');
export var getAllConfig = getWrapper('common')('getAllConfig');
export var checkColorConfig = getWrapper('common')('checkColorConfig');
export var updateColorConfig = wrapper('common')('updateColorConfig');
export var searchPkg = getWrapper('common')('searchPkg');
export var getPkgVersions = getWrapper('common')('getPkgVersions');
export var getUploadToken = getWrapper('common')('getUploadToken');
export var getCompileCSS = wrapper('common')('getCompileCSS', {
  timeout: 20000
});